import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { updateUspsLocationApi } from './updateUspsLocation.api'
import updateUspsLocationInitialState from './updateUspsLocation.initialState'
import {
  UpdateUspsLocationErrorResponse,
  UpdateUspsLocationRequest,
  UpdateUspsLocationSuccessResponse
} from './updateUspsLocation.types'

export const updateUspsLocation = createAsyncThunk(
  urls.fulfillmentOrders.updateUspsLocation,
  async (
    {
      request,
      onSuccess
    }: {
      request: UpdateUspsLocationRequest
      onSuccess?: (response: UpdateUspsLocationSuccessResponse) => void
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await updateUspsLocationApi(request)

      onSuccess?.(response)

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const updateUspsLocationSlice = createSlice({
  name: urls.fulfillmentOrders.updateUspsLocation,
  initialState: updateUspsLocationInitialState,
  reducers: {
    resetUpdateUspsLocation: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateUspsLocation.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(updateUspsLocation.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(updateUspsLocation.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as UpdateUspsLocationErrorResponse
        state.success = null
      })
  }
})

export const { actions: updateUspsLocationActions, reducer: updateUspsLocationReducer } = updateUspsLocationSlice
export const { resetUpdateUspsLocation } = updateUspsLocationActions
export default updateUspsLocationSlice.reducer
